declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false
let pixelReady = false

// Función para esperar a que fbq esté disponible
function waitForFbq(maxAttempts = 50): Promise<void> {
  return new Promise((resolve, reject) => {
    let attempts = 0
    const checkFbq = () => {
      attempts++
      if (window.fbq && typeof window.fbq === 'function') {
        pixelReady = true
        console.log('FB Pixel ready after', attempts, 'attempts')
        resolve()
      } else if (attempts >= maxAttempts) {
        console.error('FB Pixel failed to load after', attempts, 'attempts')
        reject(new Error('FB Pixel not available'))
      } else {
        setTimeout(checkFbq, 100)
      }
    }
    checkFbq()
  })
}

export function initFBPixel(pixelId: string) {
  if (initialized || typeof window === 'undefined') return

  try {
    const f = window as any
    const b = document
    const e = 'script'
    const v = 'https://connect.facebook.net/en_US/fbevents.js'

    if (f.fbq) {
      console.log('FB Pixel already initialized')
      pixelReady = true
      return
    }

    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v

    // Esperar a que el script cargue
    t.onload = () => {
      console.log('FB Pixel script loaded')
      pixelReady = true
    }

    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }

    window.fbq('init', pixelId)
    initialized = true
    console.log('FB Pixel initialized:', pixelId)

    // Esperar a que esté listo
    waitForFbq().catch((err) => console.error('FB Pixel wait failed:', err))
  } catch (err) {
    console.error('FB Pixel init failed:', err)
  }
}

export async function trackPageView() {
  try {
    if (!pixelReady) {
      await waitForFbq()
    }
    if (window.fbq) {
      window.fbq('track', 'PageView')
      console.log('✅ FB Pixel: PageView tracked')
    } else {
      console.warn('❌ FB Pixel: fbq not available for PageView')
    }
  } catch (err) {
    console.error('❌ FB Pixel PageView failed:', err)
  }
}

export async function trackAddToCart(data?: Record<string, any>) {
  try {
    if (!pixelReady) {
      console.log('Waiting for FB Pixel to be ready...')
      await waitForFbq()
    }
    if (window.fbq) {
      window.fbq('track', 'AddToCart', data)
      console.log('✅ FB Pixel: AddToCart tracked successfully', data)
      return true
    } else {
      console.warn('❌ FB Pixel: fbq not available for AddToCart')
      return false
    }
  } catch (err) {
    console.error('❌ FB Pixel AddToCart failed:', err)
    return false
  }
}
